export const FAD_JEDI_CAREERS = ["CONSULAR", "GUARD", "JEDI", "MYSTIC", "SEEKER", "SENTINEL", "WAR"];

export const CAREER_POWERS = {
  JEDI: ['ENHANCE', 'SENSE'],
  CONSULAR: ['INFLUENCE', 'MOVE'],
  GUARD: ['ENHANCE', 'PROTUNL'],
  MYSTIC: ['FORSEE', 'SENSE'],
  SEEKER: ['FARSIGHT', 'SEEK'],
  SENTINEL: ['MISDIRECT', 'MOVE'],
  WAR: ['ENHANCE', 'SENSE'],
};

export const SPEC_POWERS = {
  // Jedi 
  PADAWAN: 'ANY_1',
  GENERAL: ['ENDURE', 'BATMED'],
  KNIGHT: ['INFLUENCE', 'MOVE'],
  MASTER: 'ANY_2',
  MASTERCOTR: 'ANY_2',
  TEMPLEGUARD: ['BIND', 'SUPPRESS'],
  WAYSEEKER: ['EBBFLOW', 'FORSEE'],
  // Saber-forms
  ATARU: ['ENHANCE', 'SEEK'],
  JUYO: ['ENHANCE', 'JERINF'],
  MAKASHI: ['INFLUENCE', 'WARFOR'],
  NIMAN: ['MOVE', 'INFLUENCE'],
  SHIEN: ['MISDIRECT', 'SENSE'],
  SHIICHO: ['ENHANCE', 'ENDURE'],
  SORESU: ['ENDURE', 'SENSE'],
  // Consular 
  ARBITER: ['BIND', 'WARFOR'],
  ARCHIVIST: ['MANIPULATE', 'PSYCHOMETRY'],
  ASCETIC: ['EBBFLOW', 'ENDURE'],
  HEALER: ['HEALHARM', 'PROTUNL'],
  SAGE: ['FORSEE', 'SENSE'],
  TEACHER: ['JERINF', 'IMBUE'],
  // Guardian 
  ARMORER: ['MANIPULATE', 'ENDURE'],
  LANCER: ['MANIPULATE', 'COMMUNE'],
  PEACE: ['BATMED', 'INFLUENCE'],
  PROTECT: ['HEALHARM', 'MOVE'],
  WARDEN: ['BIND', 'JERINF'],
  WARLEADER: ['ALTER', 'FORSEE'],
  // Mystic 
  ADVISOR: ['IMBUE', 'INFLUENCE'],
  ALCHEMIST: ['HEALHARM', 'CONJURE'],
  MAGUS: ['HEALHARM', 'PROTUNL'],
  PROPHET: ['INFLUENCE', 'JERINF'],
  SEER: ['EBBFLOW', 'SEEK'],
  SHAMAN: ['ALTER', 'PSYCHOMETRY'],
  // Seeker 
  EXECUTIONER: ['BIND', 'ENHANCE'],
  HERMIT: ['ALTER', 'COMMUNE'],
  HUNTER: ['ALTER', 'WARFOR'],
  NAVIGATOR: ['EBBFLOW', 'FORSEE'],
  PATH: ['COMMUNE', 'ENDURE'],
  RECLAIMER: ['MANIPULATE', 'PSYCHOMETRY'],
  // Sentinel 
  ARTISAN: ['MANIPULATE', 'PSYCHOMETRY'],
  INVESTIGATOR: ['PSYCHOMETRY', 'SENSE'],
  RACER: ['ENHANCE', 'FORSEE'],
  SENTRY: ['ENHANCE', 'WARFOR'],
  SHADOW: ['FARSIGHT', 'SUPPRESS'],
  TRICKSTER: ['INFLUENCE', 'SENSE'],
  // Warrior 
  AGGRES: ['ENDURE', 'JERINF'],
  CHAMPION: ['INFLUENCE', 'JERINF'],
  COLOSSUS: ['BIND', 'ENDURE'],
  SLAYER: ['FARSIGHT', 'SEEK'],
  STARACE: ['MANIPULATE', 'SEEK'],
  STEELHAND: ['MOVE', 'SUPPRESS'],
};

export const getSpecPowers = (spec) => {
  if (spec && spec.CareerPowers !== undefined && spec.CareerPowers !== null && spec.CareerPowers !== "") {
    return spec.CareerPowers;
  }
  return spec ? SPEC_POWERS[spec.Key] : undefined;
};
